var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_loader_wrapper"},[_c('v-progress-circular',{staticClass:"pa-4",attrs:{"size":"150","indeterminate":"","color":"#d5b26e"}},[_c('favicon')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }